let tools3d = {
    cache_external_image(url, callback) {
        let image = new Image();
        image.crossOrigin = "anonymous";
        image.onload = () => {
            // this.re_image(image, 1024, 1024);
            callback && callback(image);
        };
        image.src = url;
        if (image.complete || image.complete === undefined) {
            image.src = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==";
            image.src = url;
        }

        return image;
    },
    // 小图片拼接成大图片，src转成Data URL形式
    re_image (img, mWidth, mHeight) {
        if (img.width >= mWidth && img.height >= mHeight) {
            return;
        }
        let testCanvas = document.createElement("canvas");
        let c = testCanvas;
        let imgW = img.width;
        let imgH = img.height;
        let wNum = Math.ceil(mWidth / imgW);
        let hNum = Math.ceil(mHeight / imgH);

        c.width = mWidth;
        c.height = mHeight;
        let ctx = c.getContext("2d");
        for (let i = 0; i <= hNum; i++) {
            for (let j = 0; j <= wNum; j++) {
                ctx.drawImage(img, j * imgW, i * imgH);
            }
        }
        let quality = 0.92;
        img = new Image();
        img.crossOrigin = "Anonymous";
        img.width = mWidth;
        img.height = mHeight;
        img.src = testCanvas.toDataURL("image/png", quality);
    },
    //测试360
    mime (option, value) {
        let mimeTypes = navigator.mimeTypes;
        for (let mt in mimeTypes) {
            if (mimeTypes[mt][option] == value) {
                return true;
            }
        }
        return false;
    },
    dataURLtoBlob(dataurl) {
        let arr = dataurl.split(','),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]),
            n = bstr.length,
            u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new Blob([u8arr], { type: mime });
    },
    //将blob转换为file
    blobToFile(theBlob, fileName){
        return new File([theBlob], fileName, {
            lastModifiedDate: new Date()
        });
    }
};

export default tools3d
